import { apiGet } from '../../api'

export const get_all_programs = () => {
  return apiGet({
    endpoint: 'programs/all_programs'
  })
}
